export const LOAD = 'AI_CHAT_ATTACHMENTS_LOAD';
export const DISCONNECT = 'AI_CHAT_ATTACHMENTS_DISCONNECT';
export const UPLOAD = 'AI_CHAT_ATTACHMENTS_UPLOAD';
export const UPLOAD_SUCCESS = 'AI_CHAT_ATTACHMENTS_UPLOAD_SUCCESS';
export const UPLOAD_FAILED = 'AI_CHAT_ATTACHMENTS_UPLOAD_FAILED';
export const CANCEL_UPLOAD = 'AI_CHAT_ATTACHMENTS_CANCEL_UPLOAD';
export const CANCEL_UPLOAD_SUCCESS = 'AI_CHAT_ATTACHMENTS_CANCEL_UPLOAD_SUCCESS';
export const CANCEL_UPLOAD_FAILED = 'AI_CHAT_ATTACHMENTS_CANCEL_UPLOAD_FAILED';
export const DELETE_ATTACHMENT = 'AI_CHAT_ATTACHMENTS_DELETE_ATTACHMENT';
export const DELETE_ATTACHMENT_SUCCESS = 'AI_CHAT_ATTACHMENTS_DELETE_ATTACHMENT_SUCCESS';
export const DELETE_ATTACHMENT_FAILED = 'AI_CHAT_ATTACHMENTS_DELETE_ATTACHMENT_FAILED';

/**
 * Subscribes to Firestore collection for the given chat.
 * Dispatched from `loadChatDataSaga` in `ai-chat` module.
 * @param {String} chatId Chat ID
 */
export const load = (chatId) => ({
  type: LOAD,
  chatId,
});

/**
 * Unsubscribes from Firestore collection.
 * Dispatched from disconnect saga in `ai-chat` module.
 * @param {String} chatId Chat ID
 */
export const disconnect = (chatId) => ({
  type: DISCONNECT,
  chatId,
});

/**
 * Initiates uploads for prepared file entries.
 * @param {Array<{ id: String, file: File, chatId: String }>} entries Prepared entries with generated IDs
 * @param {Object} context Chat context — { type, boardId, cardId? }
 * @param {String} chatId Chat ID (pre-generated if new chat)
 */
export const upload = (entries, context, chatId) => ({
  type: UPLOAD,
  entries,
  context,
  chatId,
});

/**
 * @param {String} chatId Chat ID
 * @param {String} attachmentId Attachment ID
 */
export const _uploadSuccess = (chatId, attachmentId) => ({
  type: UPLOAD_SUCCESS,
  chatId,
  attachmentId,
});

/**
 * @param {String} chatId Chat ID
 * @param {String} attachmentId Attachment ID
 * @param {String} error Error message
 */
export const _uploadFailed = (chatId, attachmentId, error) => ({
  type: UPLOAD_FAILED,
  chatId,
  attachmentId,
  error,
});

/**
 * Cancels in-progress upload. Aborts HTTP request, removes local Firestore document.
 * @param {String} chatId Chat ID
 * @param {String} attachmentId Attachment ID
 */
export const cancelUpload = (chatId, attachmentId) => ({
  type: CANCEL_UPLOAD,
  chatId,
  attachmentId,
});

/**
 * @param {String} chatId Chat ID
 * @param {String} attachmentId Attachment ID
 */
export const _cancelUploadSuccess = (chatId, attachmentId) => ({
  type: CANCEL_UPLOAD_SUCCESS,
  chatId,
  attachmentId,
});

/**
 * @param {String} chatId Chat ID
 * @param {String} attachmentId Attachment ID
 * @param {String} error Error message
 */
export const _cancelUploadFailed = (chatId, attachmentId, error) => ({
  type: CANCEL_UPLOAD_FAILED,
  chatId,
  attachmentId,
  error,
});

/**
 * Deletes a successfully uploaded (unreferenced) attachment.
 * Calls `DELETE /ai-chat-attachments/{id}`.
 * @param {String} chatId Chat ID
 * @param {String} attachmentId Attachment ID
 */
export const deleteAttachment = (chatId, attachmentId) => ({
  type: DELETE_ATTACHMENT,
  chatId,
  attachmentId,
});

/**
 * @param {String} chatId Chat ID
 * @param {String} attachmentId Attachment ID
 */
export const _deleteAttachmentSuccess = (chatId, attachmentId) => ({
  type: DELETE_ATTACHMENT_SUCCESS,
  chatId,
  attachmentId,
});

/**
 * @param {String} chatId Chat ID
 * @param {String} attachmentId Attachment ID
 * @param {String} error Error message
 */
export const _deleteAttachmentFailed = (chatId, attachmentId, error) => ({
  type: DELETE_ATTACHMENT_FAILED,
  chatId,
  attachmentId,
  error,
});
